import CloseButton, {type CloseButtonProps} from '@map/CloseButton';
import {memo} from 'react';

function PopupCloseButton({style, low, ...props}: CloseButtonProps) {
    const position = low ? {bottom: -10} : {top: -10};
    return (
        <CloseButton style={{...position, right: -10, position: 'absolute', ...style}} {...props} />
    );
}

export default memo(PopupCloseButton);
